module.exports = __webpack_public_path__ + "static/media/ai.aef06e95.png";